export default {
  TITLE: `Attributes expiration`,
  SUMMARY: `Your manager needs you to confirm that you have read the reminders sent regarding the expiration of your attributes:`,
  PRIMARY_ACTION: `I have read the reminders`,
  ATTRIBUTE: `Attribute`,
  EXPIRATIONDATE: `Expiration date`,
  REMINDERDATE: `Reminder date`
}
